export const coreRoutesNames = {
  AUTH: 'auth',
  PROFILE: 'profile',
  DASHBOARD: 'dashboard',
  NEWS: 'news',
  USERS: 'users',
};
